import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "alt-text-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M7.49904 14.6669H5.19687L4.79483 15.9687H3L5.55584 9H7.13529L9.71027 15.9687H7.90587L7.49904 14.6669ZM5.59891 13.3698H7.097L6.34556 10.9528L5.59891 13.3698Z" }, null, -1),
    _createElementVNode("path", { d: "M12.3925 14.6765H15.3168V15.9687H10.7125V9H12.3925V14.6765Z" }, null, -1),
    _createElementVNode("path", { d: "M21 10.2971H18.9084V15.9687H17.2285V10.2971H15.1752V9H21V10.2971Z" }, null, -1)
  ])))
}
export default { render: render }